/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import NProgress from 'nprogress';
import Backbone from 'backbone';
import _ from 'lodash';

import Scaffold from '@/Scaffold';
import * as NavUtils from '@/util/NavUtils';
import { userHasRole } from '@/util/RoleUtils';
import ErrorView from '@/views/ErrorView';

import GetExternalUserDetailsByID from '../../common/services/GetExternalUserDetailsByID';
import CustomerPage from '../pages/CustomerPage';

export default async function ShowCustomerPage(customerId) {
  NProgress.start();
  try {
    const isCRS = userHasRole('CRS');
    const isAdmin = userHasRole('Admin');

    if (!isCRS && !isAdmin) {
      showAuthError();
      return;
    }

    const userDetails = await GetExternalUserDetailsByID(customerId);
    userDetails.fullName = `${userDetails.firstName} ${userDetails.lastName}`;

    NavUtils.navigate(`customer/${customerId}`);
    Scaffold.getRegion('content').show(
      new CustomerPage({
        model: new Backbone.Model({
          customerId,
          customerDetails: userDetails
        })
      })
    );
  } catch(err) {
    Scaffold.getRegion('content').show(
      new ErrorView({
        model: new Backbone.Model({
          errorMessage: _.isString(err.message) ? err.message : 'An Error Occurred',
          errorDetails: 'Something went wrong while loading the Customer page.'
        })
      })
    );
  } finally {
    NProgress.done();
  }

  function showAuthError(err) {
    Scaffold.getRegion('content').show(
      new ErrorView({
        model: new Backbone.Model({
          errorMessage: _.isString(err?.message) ? err?.message : 'Access Denied',
          errorDetails: 'Your account may not have permission to view the Customer page.'
        })
      })
    );
    NProgress.done();
  }
}
